<template>
  <div class="site-view" v-if="pageData">
    <section class="site-text">
      <div class="container">
        <MapModal
          :data="selectedMapData"
          v-if="modalShow"
          @modalClosed="closeModal"
        />
        <div class="row mb-0">
          <div class="col s12">
            <div class="header-section">
              <div class="text">
                <h1>The proposed scheme</h1>
                <p>
                  The scheme is split into two parts – the section between
                  Elmbridge Court Roundabout to Arle Court Roundabout will start
                  first. The second section between Elmbridge Court Roundabout
                  and Estcourt Road Roundabout will have a separate consultation
                  at a later date.
                </p>
                <p>
                  The Cycleway will provide a continuous a segregated cycle
                  track from Elmbridge Court Roundabout to Staverton Junction
                  and a shared use cycle track from Staverton to Arle Court
                  Roundabout where there are few pedestrians. A shared use cycle
                  track is designed around the needs of cycles (with appropriate
                  gradients, priority at side road etc.) but pedestrians can use
                  it.
                </p>
                <p>
                  Beyond the physical changes, the county council is also
                  working with road safety and police colleagues to on the
                  possibility of reducing the 50mph speed limit between the
                  Brickhampton Court Golf Complex and Arle Court Roundabout, to
                  40mph. Discussions are ongoing.
                </p>
                <p>
                  Computer generated images of the planned Cycleway can be
                  viewed by clicking on the numbered markers below.
                </p>
              </div>
              <div class="image">
                <div
                  :style="{
                    'background-image': `url(${require('@/assets/images/CycleRoute/GCC_Proposed-scheme.jpg')})`,
                  }"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div v-html="pageData.properties.pageDescription"></div> -->
      <div class="map-section">
        <div class="container">
          <h1 style="color: white">Scheme visualisations</h1>
          <p style="color: white">
            Computer generated images of the planned Cycleway can be viewed by
            clicking on the numbered markers below.
          </p>
          <div
            id="map"
            :style="{
              'background-image': `url(${require('@/assets/images/CycleRoute/mapOverview.jpg')})`,
            }"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              version="1.1"
              x="0px"
              y="0px"
              viewBox="0 0 2667 1493.4"
              style="enable-background: new 0 0 2667 1493.4"
              xml:space="preserve"
            >
              <g id="Layer_1">
                <g id="Pins">
                  <g @click="showModal('pin1b')" class="map-pins">
                    <g>
                      <path
                        class="st0"
                        d="M1153.4,516.1c-20.8,0.1-37.6,17-37.5,37.8c0,29.6,34,60.2,35.4,61.4c1.2,1.1,3,1.1,4.2,0
	c1.4-1.3,35.4-31.8,35.4-61.4C1190.9,533.1,1174.1,516.2,1153.4,516.1z M1153.4,574.4c-11.5,0-20.8-9.3-20.8-20.8
	c0-11.5,9.3-20.8,20.8-20.8c11.5,0,20.8,9.3,20.8,20.8c0,0,0,0,0,0C1174.2,565.1,1164.9,574.4,1153.4,574.4z"
                      />
                      <circle class="st1" cx="1153.4" cy="552.4" r="25.1" />
                      <path
                        class="st0"
                        d="M1135.5,560.4h5.8v-14.9c0-0.9,0-1.8,0-1.8h-0.1c-0.3,0.6-0.7,1.1-1.2,1.5l-2.2,2l-2.9-3l6.7-6.5h4.3v22.7h5.8
	v4.2h-16.4L1135.5,560.4z"
                      />
                      <path
                        class="st0"
                        d="M1165.3,552.5h0.6v-0.3c0-2.5-1.6-3.4-3.7-3.4c-1.9,0.1-3.7,0.8-5.3,1.9l-1.8-3.4c2.2-1.6,4.9-2.4,7.6-2.4
	c5.1,0,8,2.8,8,7.7v12.1h-4.4v-1.6c0-0.5,0-0.9,0.1-1.4h-0.1c-1.1,2.2-3.4,3.5-5.9,3.4c-3.4,0-6.6-2.2-6.6-6
	C1153.9,552.9,1162.2,552.5,1165.3,552.5z M1161.7,561.4c2.5,0,4.4-2.7,4.4-5.1v-0.5h-0.8c-2.5,0-6.4,0.3-6.4,3
	C1158.7,560.1,1159.7,561.4,1161.7,561.4z"
                      />
                    </g>
                  </g>

                  <g @click="showModal('pin1a')" class="map-pins">
                    <g>
                      <path
                        class="st0"
                        d="M1214.9,461.1c-20.8,0.1-37.6,17-37.5,37.8c0,29.6,34,60.2,35.4,61.4c1.2,1.1,3,1.1,4.2,0
	c1.4-1.3,35.4-31.8,35.4-61.4C1252.4,478.1,1235.7,461.2,1214.9,461.1z M1214.9,519.5c-11.5,0-20.8-9.3-20.8-20.8
	c0-11.5,9.3-20.8,20.8-20.8c11.5,0,20.8,9.3,20.8,20.8c0,0,0,0,0,0C1235.7,510.1,1226.4,519.5,1214.9,519.5z"
                      />
                      <circle class="st1" cx="1214.9" cy="497.4" r="25.1" />
                      <path
                        class="st0"
                        d="M1195.6,505.5h5.8v-14.9c0-0.9,0-1.8,0-1.8h-0.1c-0.3,0.6-0.7,1.1-1.2,1.5l-2.2,2l-2.9-3l6.7-6.5h4.3v22.7h5.8
	v4.2h-16.4L1195.6,505.5z"
                      />
                      <path
                        class="st0"
                        d="M1215.6,482.8h4.8v8.3c0,0.9-0.1,1.6-0.1,1.6h0.1c1.3-1.8,3.5-2.9,5.8-2.8c5.2,0,8.6,4.1,8.6,10.1
	c0,6.1-3.8,10.1-8.9,10.1c-2.3,0.1-4.4-1-5.8-2.9h-0.1c0.1,0.4,0.1,0.9,0.1,1.3v1.1h-4.5V482.8z M1225.1,506.1c2.7,0,4.8-2.2,4.8-6
	c0-3.7-2-6.1-4.8-6.1c-2.5,0-4.8,1.8-4.8,6.1C1220.3,503.1,1221.9,506.1,1225.1,506.1z"
                      />
                    </g>
                  </g>

                  <g @click="showModal('pin3')" class="map-pins">
                    <g>
                      <path
                        class="st0"
                        d="M1305.8,320.2c-20.8,0.1-37.6,17-37.5,37.8c0,29.6,34,60.2,35.4,61.4c1.2,1.1,3,1.1,4.2,0
		c1.4-1.3,35.4-31.8,35.4-61.4C1343.3,337.2,1326.5,320.3,1305.8,320.2z M1305.8,378.5c-11.5,0-20.8-9.3-20.8-20.8
		s9.3-20.8,20.8-20.8c11.5,0,20.8,9.3,20.8,20.8v0C1326.6,369.2,1317.3,378.5,1305.8,378.5z"
                      />
                      <circle class="st1" cx="1305.8" cy="356.5" r="25.1" />
                      <path
                        class="st0"
                        d="M1296.7,368.4c0-9.7,12.6-11.3,12.6-16.6c0-2.3-1.8-3.8-4.1-3.8c-3.1,0-4.8,3.2-4.8,3.2l-3.6-2.4
		c1.7-3.3,5.2-5.4,8.9-5.4c4.7,0,8.8,2.9,8.8,8c0,8.6-12,10.1-12.2,15.2h12.6v4.2h-17.8C1296.8,370,1296.7,369.2,1296.7,368.4z"
                      />
                    </g>
                  </g>

                  <g @click="showModal('pin4')" class="map-pins">
                    <g>
                      <path
                        class="st0"
                        d="M2183.6,285.8c-20.8,0.1-37.6,17-37.5,37.8c0,29.6,34,60.2,35.4,61.4c1.2,1.1,3,1.1,4.2,0
		c1.4-1.3,35.4-31.8,35.4-61.4C2221.2,302.8,2204.4,285.9,2183.6,285.8L2183.6,285.8z M2183.6,344.1c-11.5,0-20.8-9.3-20.8-20.8
		c0-11.5,9.3-20.8,20.8-20.8c11.5,0,20.8,9.3,20.8,20.8c0,0,0,0,0,0C2204.4,334.8,2195.1,344.1,2183.6,344.1L2183.6,344.1z"
                      />
                      <circle class="st1" cx="2183.6" cy="322.1" r="25.1" />
                      <path
                        class="st0"
                        d="M2175.3,329.5c1.6,1.6,3.8,2.6,6.1,2.7c2.8,0,4.9-1.7,4.9-4c0-2.8-2.6-4.2-5.8-4.2h-1.9l-1.1-2.5l4.9-5.8
		c0.6-0.7,1.2-1.4,1.9-2v-0.1c-0.8,0.1-1.6,0.1-2.4,0.1h-8v-4.2h16.4v3.1l-6.6,7.6c3.7,0.5,7.4,3.2,7.4,7.8c0,4.6-3.5,8.8-9.5,8.8
		c-3.3,0-6.5-1.3-8.9-3.6L2175.3,329.5z"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
        </div>
      </div>
    </section>

    <!-- <SiteAccordion :data="faqItems" :headerField="'question'" :contentField="'answer'" /> -->

    <SiteFooter />
  </div>
</template>

<script>
import firebase from "firebase";
import Settings from "@/mixins/AppSettings.js";
import { mapState, mapGetters } from "vuex";
import Logo from "@/assets/images/heathrow/logo.png";
import Branding from "@/components/Branding";
import SiteAccordion from "@/components/customPages/components/accordion.vue";
import SiteFooter from "@/components/customPages/components/footer.vue";
import _ from "lodash";
import MapFunctions from "@/functions/svg.js";
import MapSvg from "@/assets/images/maps/map.svg";
import MapModal from "@/components/MapModal.vue";

export default {
  data() {
    return {
      modalShow: false,
      baseMapPath: "@/assets/images/modalImages/",
      selectedMapData: {},
    };
  },

  name: "StaticMap",
  components: {
    Branding,
    SiteAccordion,
    SiteFooter,
    MapModal,
  },
  methods: {
    showModal(elId) {
      this.selectedMapData = {};
      this.selectedMapData = this.allEntities.filter(
        (d) => d.pinId === elId && d.type === "mapItem"
      )[0];

      if (this.selectedMapData) {
        this.selectedMapData.imageUrl = require(`@/assets/modalImages/${this.selectedMapData.image}`);
        this.modalShow = true;
      } else {
        console.log("No data matched in data store for pin with ID", elId);
      }
    },
    closeModal(e) {
      this.selectedMapData = {};
      this.modalShow = false;
    },
  },
  computed: {
    ...mapState(["entities", "entityTypes"]),
    ...mapGetters(["user", "allEntityTypes", "allEntities"]),
    pageData() {
      if (this.$route.params.id != undefined) {
        return this.allEntities.find(
          (item) => item.docId == this.$route.params.id
        );
      } else {
        return this.allEntities.find(
          (item) => item.type == this.$route.params.templateName
        );
      }
    },
  },
  watch: {
    $route(to, from) {
      this.activeInstance = to.params.root;
    },
  },
};
</script>

<style lang="scss" scoped>
.header-section {
  padding: 30px 0 50px;
  display: flex;
  flex-direction: row;

  .text {
    width: 50%;
    padding: 0 20px;
    margin: auto 0;
  }

  .image {
    width: 50%;
    justify-content: center;
    padding: 0 20px;
    height: 450px;

    div {
      width: 100%;
      height: 100%;
      background-size: cover;
      background-position: center;
    }
  }
}

#map {
  background-size: contain;
  background-repeat: no-repeat;
  width: 100%;
  max-width: 100%;
}
.map-pins {
  cursor: pointer;
  -webkit-transform-origin: 50% 50%;
  transform-origin: 50% 50%;

  &:hover {
    // transition: 1.5 ease;
    // transform: scale(1.2);
    fill: green;
  }
}

.st0 {
  fill: #00669b;
}
.st1 {
  fill: #ffffff;
}
path[id^="pin"] {
  cursor: pointer;
}

.map-section {
  background-color: #0055a5;
  padding: 50px 0;
  width: 100%;
}

@media (max-width: 950px) {
  .header-section {
    flex-direction: column !important;

    .text {
      width: 100%;
    }

    .image {
      width: 100%;
      height: 500px;

      div {
        height: 100%;
      }
    }
  }
}
</style>
